"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMenuItemToggleRow = exports.withMenuItemToggleState = exports.renderMenuItemContent = exports.renderMenuItemRow = exports.withMenuItemPresentation = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/list-item/list-item");
const toggle_controller_1 = require("@/controllers/toggle-controller");
/**
 * 표시 prop을 한 곳에서 선언하는 mixin. role·상태·이벤트 같은 시멘틱은 각 컴포넌트가 소유하고,
 * 행 콘텐츠로 흐르는 반복 prop과 host 스타일 상태(tone)만 공유한다.
 */
const withMenuItemPresentation = (Base) => {
    class MenuItemPresentationElement extends Base {
        constructor() {
            super(...arguments);
            this.size = 'small';
            this.tone = '';
            this.label = '';
            this.description = '';
            this.emoji = '';
            this.avatarSrc = '';
            this.avatarVariant = 'tertiary';
            this.avatarShape = 'square';
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: String, reflect: true })
    ], MenuItemPresentationElement.prototype, "size", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, reflect: true })
    ], MenuItemPresentationElement.prototype, "tone", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], MenuItemPresentationElement.prototype, "label", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], MenuItemPresentationElement.prototype, "description", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], MenuItemPresentationElement.prototype, "icon", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], MenuItemPresentationElement.prototype, "emoji", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
    ], MenuItemPresentationElement.prototype, "avatarSrc", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'avatar-variant' })
    ], MenuItemPresentationElement.prototype, "avatarVariant", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'avatar-shape' })
    ], MenuItemPresentationElement.prototype, "avatarShape", void 0);
    return MenuItemPresentationElement;
};
exports.withMenuItemPresentation = withMenuItemPresentation;
/** checkbox·radio·switch 계열이 공유하는 선택 가능한 행. role·상태·키보드 활성화를 행이 소유한다. */
function renderMenuItemRow(options, content) {
    const handleKeydown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ')
            return;
        event.preventDefault();
        options.onActivate();
    };
    return (0, lit_1.html) `
    <div
      role=${options.role}
      tabindex=${options.disabled ? '-1' : '0'}
      aria-disabled=${(0, if_defined_js_1.ifDefined)(options.disabled ? 'true' : undefined)}
      aria-checked=${(0, if_defined_js_1.ifDefined)(options.ariaChecked ?? undefined)}
      @click=${options.onActivate}
      @keydown=${handleKeydown}
    >
      ${content}
    </div>
  `;
}
exports.renderMenuItemRow = renderMenuItemRow;
function renderMenuItemContent(props, trailing) {
    return (0, lit_1.html) `
    <mm-list-item
      size=${props.size}
      label=${props.label}
      description=${props.description}
      icon=${(0, if_defined_js_1.ifDefined)(props.icon)}
      emoji=${(0, if_defined_js_1.ifDefined)(props.emoji || undefined)}
      avatar-src=${(0, if_defined_js_1.ifDefined)(props.avatarSrc || undefined)}
      avatar-variant=${props.avatarVariant}
      avatar-shape=${props.avatarShape}
    >
      ${trailing}
    </mm-list-item>
  `;
}
exports.renderMenuItemContent = renderMenuItemContent;
/**
 * menu-item-checkbox·menu-item-switch가 공유하는 checked 상태와 토글 배선.
 * 트레일링 컨트롤(mm-checkbox/mm-switch)만 각 컴포넌트가 소유한다.
 */
const withMenuItemToggleState = (Base) => {
    class MenuItemToggleStateElement extends Base {
        constructor() {
            super(...arguments);
            this.disabled = false;
            this.checked = false;
            this.value = '';
            this.toggle = new toggle_controller_1.ToggleController(this, 'checked');
            this.activate = () => {
                this.toggle.toggle();
            };
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], MenuItemToggleStateElement.prototype, "disabled", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], MenuItemToggleStateElement.prototype, "checked", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], MenuItemToggleStateElement.prototype, "value", void 0);
    return MenuItemToggleStateElement;
};
exports.withMenuItemToggleState = withMenuItemToggleState;
/**
 * checkbox·switch 계열이 공유하는 토글 행 조립.
 * role은 겉모습이 아니라 행이 놓이는 부모에 맞춰 각 컴포넌트가 정한다.
 */
function renderMenuItemToggleRow(props, role, trailing) {
    return renderMenuItemRow({
        role,
        disabled: props.disabled,
        ariaChecked: props.checked ? 'true' : 'false',
        onActivate: props.activate,
    }, renderMenuItemContent(props, trailing));
}
exports.renderMenuItemToggleRow = renderMenuItemToggleRow;
//# sourceMappingURL=data:application/json;base64,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